export default __webpack_public_path__ + "static/study-banner768-7a40aa1d4ff1378c424c3ac09174f9aa.jpg";